import React, { useContext, useRef, useEffect } from 'react';
import styled from 'styled-components/macro';

import { LevelButtons, fontkoKR } from '@mirinae/react-ui';

import PlayerContext from '@mirinae/lessons/modules/contexts/player';
import { lessonsPalette, lessonsSizes } from '@mirinae/lessons/modules/defines/styles';
import GlobalContext from '@mirinae/lessons/modules/contexts/global';

const PatternHeaderWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

const TitleRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    svg {
        margin-right: 10px;
    }
`;

const TagRow = styled.div`
    margin-top: 5px;
`;

const Title = styled.div`
    color: ${lessonsPalette.primary.black};
    font-size: 18px;
    font-weight: 700;
    font-family: ${fontkoKR};

`;
const TitleLink = styled.span`
    cursor: pointer;
    :hover {
        color: ${lessonsPalette.default[0]};
    }
`;
const MiniLessonsTitle = styled.span`
    margin-left: 4px;
    color: ${lessonsPalette.default[4]};
    // span {
    //     color: ${lessonsPalette.default[4]};
    // }
`;
const Tag = styled.span`
    display: inline-block;
    color: ${lessonsPalette.grey[2]};
    font-size: 14px;
    font-weight: 400;
    &:before {
        content: '#';
        margin-right: 5px;
        color: ${lessonsPalette.default[0]};
        font-style: italic;
        font-weight: 700;
        font-size: 18px;
        vertical-align: middle;
    }
    & + & {
        margin-left: 10px;
    }
    opacity: 0;
`;

// standard header component for pattern lessons (shows level, pattern title, subtitle, tags, etc.)
const PatternHeader = ({ page }) => {
    const player = useContext(PlayerContext);
    const globalContext = useContext(GlobalContext);
    const tagsString = globalContext.currentLessonObject.tags || player.currentLesson.tags;
    const tags = tagsString.trim().split(' ');
    const refs = tags.map(() => useRef(null));

    useEffect(() => {
        // ellipsis truncation hack for narrow mobile devices
        refs.filter(ref => ref.current).find(ref => {
            ref.current.style.opacity = 1;
            if (ref.current.getBoundingClientRect().right > lessonsSizes.lessonBounds.width - 50) { // on mobile devices, the 50 px clears the exit icon
                ref.current.textContent = '...';
                return true;
            }
        });
    }, []);

    const gotoLessonStart = () => {
        player.gotoPage(null, { page: player.currentLesson.children[0].children[0] });
    };

    return (
        <PatternHeaderWrapper page={page}>
            <TitleRow>
                {player.currentLesson.levelTitle && <LevelButtons width="50" height="20" level={player.currentLesson.levelTitle} />}
                <Title>
                    <TitleLink onClick={gotoLessonStart}>
                        {player.currentLesson.title}
                    </TitleLink>
                    {player.currentSection.miniLesson && <MiniLessonsTitle>(<span>{player.currentSection.title.replace('mini-lesson', '').trim()}</span>)</MiniLessonsTitle>}
                </Title>
            </TitleRow>
            <TagRow>
                { tags.map((tag, i) => (
                    <Tag ref={refs[i]} key={tag}>{tag.replace(/^#+/, '')}</Tag>
                ))}
            </TagRow>
        </PatternHeaderWrapper>
    );
};

export default PatternHeader;
